import React from 'react';
import { Box, IconButton, Paper, Tooltip, Snackbar, Alert, Divider } from "@mui/material";
import { styled } from '@mui/material/styles';
import Editor from '@monaco-editor/react';
import Service from "../../../../util/Service";
import { Download, Event, FileUpload } from '@mui/icons-material';
import CamelMongoDBModel from './CamelMongoDBModel';
import { copyStringToClipboard, prettify } from '../../../../util/Utilitarios';
import { Toolbar } from 'react-simple-wysiwyg';
import CamelNotifiPopover from './CamelNotifiPopover';
import CamelGitPopover from './CamelGitPopover';
import CamelSystemPopover from './CamelSystemPopover';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

const NodeScriptTaskCamel = React.forwardRef((props, ref) => {
    const { item, processo, tipo } = props;
    const editorRef = React.useRef(null);
    const [themeEditor, setThemeEditor] = React.useState('vs-dark');
    const refCode = React.useRef();

    const [msg, setMsg] = React.useState();
    const [openSnack, setOpenSnack] = React.useState(false);


    const [code, setCode] = React.useState('');

    React.useImperativeHandle(ref, () => ({
        childMethod() {
            salva();
        }
    }))

    React.useEffect(() => {
        const tk = processo.lstTask.find(t => t.idTask === item.id);
        if (tk) {
            setCode(tk.code)
        } else {
            Service.FETCH("/api/bpmn/buscaCodigoExemplo/camel-bpmToDB.txt")
                .then(r => {
                    setCode(r)
                });
        }
    }, [])
    const salva = (val) => {
        const send = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,
            tipo: tipo,
            // nome: item.businessObject.name,
            code: code
            // url: url,
            // method: method,
            // dado: dado,
            // header:headers            
        }
        if (val) {
            send.code = val
        }

        Service.POST("/api/bpmn/salvarTaskDoProcesso", send).then(resp => {
            console.log(resp);
        }).catch(error => {
            console.error(error)
        })
    };
    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
        editor.addCommand(
            monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, // Use CtrlCmd for cross-platform support (Cmd on Mac, Ctrl on Windows/Linux)
            function () {
                if (salva) salva(editor.getValue());
                else console.error("SaveAction não informada!")
            },
            null
        );
    }
    const handleUpload=(e)=>{
        const file = document.getElementById("fileCode");
        file.click();
    }
    const upload = () => {
        let input = document.getElementById("fileCode");
        const file = input.files[0];
        if (file) {
        
            if (file.type !== "text/javascript") {
                alert("Aceita apenas arquivos javascript (.js)");
                input.value = ''; // Clear the input to allow re-selection
                return;
            }
            const fileReader = new FileReader();
            fileReader.onload = event => {
                setCode(event.target.result)
                input.value = '';
            }            
            fileReader.readAsText(file);
        }
    }
    const handleDownload = () => {
        const nome = item.businessObject.name;
        const blob = new Blob([code], { type: 'application/txt' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = nome+'.js'; // Set the desired file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsg();
        setOpenSnack(false);
    };

    function handleCamelNotificacao() {
        console.log('>>>handleCamelNotificacao<<<');
    }
    function handleCamelEvento() {
        Service.GET("/api/security/model/camelEvento").then(r => {
            if (r.success) {

                const jsonString = prettify(r.code);
                copyStringToClipboard(jsonString);
                setOpenSnack(true);
                setMsg("Código copiado");
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }
    function handleCamelMongoQuery(modelo) {
        Service.GET("/api/security/model/camelMongoQuery/" + modelo).then(r => {
            if (r.success) {
                // const jsonString = prettify(r.code);
                copyStringToClipboard(r.code);
                setOpenSnack(true);
                setMsg("Código copiado");
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }

    return (
        <Box>
            {/* <Stack direction="row" spacing={0} id='editor_tool'> */}
            <Toolbar >
                <Tooltip title="Gerar Evento">
                    <IB
                        variant='container'
                        onClick={handleCamelEvento}
                        size="small"
                    >
                        <Event />
                    </IB>
                </Tooltip>
                {/* <Tooltip title="Exemplo notificação">
                    <IB
                        variant='container'
                        onClick={handleCamelNotificacao}
                        size="small"
                    >
                        <EditNotifications />
                    </IB>
                </Tooltip> */}
                <CamelNotifiPopover action={handleCamelMongoQuery} setCode={setCode} />
                <CamelGitPopover action={handleCamelMongoQuery} setCode={setCode} />
                <CamelSystemPopover action={handleCamelMongoQuery} setCode={setCode} />
                <Divider orientation="vertical" flexItem sx={{ ml: '10px', mr: '5px' }} variant="middle" />
                
                <CamelMongoDBModel action={handleCamelMongoQuery} setCode={setCode} />
                <Box component="div" sx={{ flexGrow: 1 }} />

                <Tooltip title="Upload codigo">
                    <IB
                        variant='container'
                        onClick={handleUpload}
                        size="small"
                    >
                        <FileUpload />
                    </IB>
                </Tooltip>
                <Tooltip title="Download codigo">
                    <IB
                        variant='container'
                        onClick={handleDownload}
                        size="small"
                    >
                        <Download />
                    </IB>
                </Tooltip>

            </Toolbar>
            {/* </Stack> */}
            <Paper sx={{ mt: 0 }}>
                {/* <Editor
                value={code}
                onValueChange={t => setCode(t)}
                highlight={code => {
                    // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                    return highlight(code, languages.js)
                }}
                padding={10}
                style={{
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 12,
                    minHeight:'400px'
                }}
            /> */}
                <Editor
                    height={"80vh"}
                    //width={style? style.width: '100%'}
                    defaultLanguage="javascript"
                    theme={themeEditor}
                    value={code}
                    onChange={t => setCode(t)}
                    onMount={handleEditorDidMount}
                    options={{
                        minimap: {
                            enabled: false,
                        },
                    }}
                />
            </Paper>

            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
            <input type="file" id="fileCode" style={{ display: 'none' }} 
                onChange={upload} accept=".js, text/plain"
            />
        </Box>
    )
})

export default NodeScriptTaskCamel;